import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgClose = function SvgClose(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("path", {
      d: "M18.4277 18.4286L5.57059 5.57144",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M18.4284 5.57144L5.57129 18.4286",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
};

export { SvgClose as default };
